import { useState } from 'react';
import { collection, addDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './LabRegistration.css';

function LabRegistration() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    company: '',
    jobTitle: ''
  });
  const [status, setStatus] = useState('');
  const [errors, setErrors] = useState({});

  const validateEmail = (email) => {
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateField = (name, value) => {
    if (value.length > 100) {
      return `${name} must be 100 characters or less`;
    }
    if (name === 'email' && !validateEmail(value)) {
      return 'Please enter a valid email address';
    }
    return '';
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const error = validateField(name, value);
    
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    setErrors(prev => ({
      ...prev,
      [name]: error
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    let isValid = true;

    ['fullName', 'email', 'company', 'jobTitle'].forEach(field => {
      if (!formData[field].trim()) {
        newErrors[field] = 'This field is required';
        isValid = false;
      } else {
        const error = validateField(field, formData[field]);
        if (error) {
          newErrors[field] = error;
          isValid = false;
        }
      }
    });

    setErrors(newErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setStatus('submitting');
    
    try {
      await addDoc(collection(db, 'lab-registrations'), {
        ...formData,
        timestamp: new Date()
      });
      setStatus('success');
      setFormData({
        fullName: '',
        email: '',
        company: '',
        jobTitle: ''
      });
      setErrors({});
    } catch (error) {
      console.error('Error submitting form:', error);
      setStatus('error');
    }
  };

  return (
    <div className="App" style={{ height: '100vh', overflow: 'hidden' }}>
      <header className="App-header" style={{ height: '100%', overflow: 'hidden' }}>
        <div className="lab-registration">
          <h1>Lab Registration</h1>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="fullName">Full Name</label>
              <input
                type="text"
                id="fullName"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                maxLength={100}
                required
              />
              {errors.fullName && <span className="error-text">{errors.fullName}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                maxLength={100}
                required
              />
              {errors.email && <span className="error-text">{errors.email}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="company">Company</label>
              <input
                type="text"
                id="company"
                name="company"
                value={formData.company}
                onChange={handleChange}
                maxLength={100}
                required
              />
              {errors.company && <span className="error-text">{errors.company}</span>}
            </div>

            <div className="form-group">
              <label htmlFor="jobTitle">Job Title</label>
              <input
                type="text"
                id="jobTitle"
                name="jobTitle"
                value={formData.jobTitle}
                onChange={handleChange}
                maxLength={100}
                required
              />
              {errors.jobTitle && <span className="error-text">{errors.jobTitle}</span>}
            </div>

            <button type="submit" disabled={status === 'submitting'}>
              {status === 'submitting' ? 'Submitting...' : 'Register'}
            </button>

            {status === 'success' && (
              <div className="success-message">
                Registration successful! Thank you for registering.
              </div>
            )}

            {status === 'error' && (
              <div className="error-message">
                There was an error submitting your registration. Please try again.
              </div>
            )}
          </form>
        </div>
      </header>
    </div>
  );
}

export default LabRegistration; 